<template>
    <div class="main-container">
        <div class="headers">
            <div class="btns">
                <el-button size="mini" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </div>
            <div>案例示范</div>
        </div>
        <el-row>
            <el-col :span="6" v-for="item in v_data" :key="item.pk">
                <el-card :body-style="{ padding: '0px' }">
                    <img src="../../assets/images/help1.jpg" class="image">
                    <div style="padding: 14px;">
                        <span>{{item.remark}}</span>
                        <div class="bottom clearfix">
                            <time class="time">{{ item.created }}</time>
                            <el-button type="text" class="button" @click="video0(item.video)">点击播放</el-button>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6" v-for="item in f_data" :key="item.pk">
                <el-card :body-style="{ padding: '0px' }">
                    <img src="../../assets/images/help-pdf.png">
                    <div style="padding: 14px;">
                        <span>{{item.remark}}</span>
                        <div class="bottom clearfix">
                            <time class="time">{{ item.created }}</time>
                            <el-button type="text" class="button" @click="files(item.file)">点击查看</el-button>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
                title="视频"
                :visible.sync="dialogVisible"
                width="60%"
        >
            <div class="main-container">
                <video-player class="video-player-box"
                              ref="videoPlayer"
                              :options="playerOptions"
                              :playsinline="false"
                              customEventName="customstatechangedeventname">
                </video-player>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import 'video.js/dist/video-js.css'
    import {videoPlayer} from 'vue-video-player'

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                playerOptions: {
                    width: 800,
                    muted: true,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        src: ""
                    }],
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true  //全屏按钮
                    }
                },
                dialogVisible: false,
                v_data: [],
                f_data: [],
            };
        },
        methods: {
            getData() {
                this.$http.get(`/demonstration/list/`)
                    .then(resp => {
                        this.v_data = resp.data.v_data
                        this.f_data = resp.data.f_data
                    })
                    .catch((err) => {
                        console.log(err)
                        this.loading = false
                    })
            },
            video0(video) {
                this.dialogVisible = true
                if (video) {
                    this.playerOptions['sources'] = [{
                        src: video,
                        type: "video/mp4",
                    }]
                }
            },
            files(file) {
                if (file) {
                    window.open(file);
                }
            },

        },
        mounted() {
            this.getData()
        }
    };
</script>
<style scoped>
    .headers {
        padding-bottom: 10px;
        border-bottom: 1px solid #EBEEF5;
        margin-bottom: 10px;
    }

    .btns {
        float: right;
    }

    .el-card {
        margin: 5px;
    }

    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

</style>

